import React, { useEffect, useState } from 'react';

import { styled, Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

import Button from 'components/Button';
import { FabButton } from 'components/buttons';
import { Div_AddBtnWrapper } from 'components/SimpleFCTable/styled-components';
import Add from 'components/SvgComponents/icons/Add';
import AddFormDialog from 'containers/OneProjectPage/FormsPage/components/AddFormDialog';
import globalMessages from 'translations/messages/global-messages';
import { handleToggleDialog } from 'utils/dialog';

const styles = {
  addFormGenericButton: {
    textAlign: 'center',
  },
  typographyEllipsisWidth: {
    maxWidth: '200px',
  },
};

const Div_MarginBottom = styled('div')(({ theme }) => ({
  height: theme.spacing(4),
}));

const AddForm = ({
  intl,
  classes,
  buttonType = 'generic',
  canCreateForm = false,
  disabled,
  moduleId,
  beforeOpenDialog,
  openDialog,
  position,
  disableRedirect,
  addButtonLabel,
  onFormCreated,
  source,
  onCloseDialog,
  customStyleButtonWrapper,
  isGuest = false,
}) => {
  const [activeDialog, setActiveDialog] = useState(false);

  const handleCreateForm = () => {
    if (beforeOpenDialog) {
      beforeOpenDialog();
    } else {
      setActiveDialog(true);
    }
  };

  useEffect(
    () => {
      if (openDialog) setActiveDialog(true);
    },
    [openDialog],
  );

  return !canCreateForm ? (
    <Div_MarginBottom />
  ) : (
    <>
      <Div_AddBtnWrapper>
        {buttonType === 'generic' ? (
          <div className={classNames(classes.addFormGenericButton, customStyleButtonWrapper)}>
            <Tooltip
              title={(() => {
                if (isGuest) {
                  return intl.formatMessage(globalMessages.no_right_to_create_item);
                }
                return '';
              })()}
            >
              <span>
                <Button onClick={handleCreateForm} startIcon={<Add />} disabled={disabled}>
                  {addButtonLabel || intl.formatMessage(globalMessages.create_form)}
                </Button>
              </span>
            </Tooltip>
          </div>
        ) : (
          <FabButton onClick={handleToggleDialog(setActiveDialog, activeDialog)} />
        )}
      </Div_AddBtnWrapper>
      <AddFormDialog
        activeDialog={openDialog || activeDialog}
        onCloseDialog={() => {
          if (onCloseDialog) {
            onCloseDialog();
          }
          setActiveDialog(false);
        }}
        moduleId={moduleId}
        position={position}
        disableRedirect={disableRedirect}
        onFormCreated={onFormCreated}
        source={source}
      />
    </>
  );
};

AddForm.propTypes = {
  classes: PropTypes.object,
  intl: PropTypes.object.isRequired,
  buttonType: PropTypes.string,
  canCreateForm: PropTypes.bool,
  disabled: PropTypes.bool,
  moduleId: PropTypes.string,
  beforeOpenDialog: PropTypes.func,
  openDialog: PropTypes.bool,
  position: PropTypes.object,
  disableRedirect: PropTypes.bool,
  addButtonLabel: PropTypes.string,
  onFormCreated: PropTypes.func,
  source: PropTypes.string,
  onCloseDialog: PropTypes.func,
  customStyleButtonWrapper: PropTypes.string,
  isGuest: PropTypes.bool,
};

export default compose(
  injectIntl,
  withStyles(styles),
)(AddForm);
